// extracted by mini-css-extract-plugin
module.exports = {"BreadcrumbsMenu":"UserBreadcrumbs_BreadcrumbsMenu__1BkdW","ant-menu-horizontal":"UserBreadcrumbs_ant-menu-horizontal__1J-Ex"};